module.exports = __webpack_public_path__ + "static/img/x6.75dd0f50.png";